export default (a:any, b:any):number => {
  // eslint-disable-next-line eqeqeq
  if (a == b) return 0;
  return a < b ? -1 : 1;
};
